define('helper-entity-isInPageRange',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (entities, ID, startID, endID) {

        if (!Array.isArray(entities) || !ID || typeof ID !== 'string' || !startID || typeof startID !== 'string' || !endID || typeof endID !== 'string') {
            return false;
        }

        var trainingMap = [],
            flatten = function flatten(arr) {
            for (var i = 0; i < arr.length; i++) {
                trainingMap.push(arr[i].contentEntityId);

                if (arr[i].children && arr[i].children.length) {
                    flatten(arr[i].children);
                }
            }
        };

        flatten(entities);

        var currentIndex = trainingMap.indexOf(ID),
            startIndex = trainingMap.indexOf(startID),
            endIndex = trainingMap.indexOf(endID || startID);

        if (isNaN(currentIndex) || isNaN(startIndex)) {
            console.warn("currentIndex or startIndex == NaN in currentInRange");
            return false;
        } else {
            return currentIndex >= startIndex && currentIndex <= endIndex;
        }
    };
});
